"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableDTO = void 0;
const index_js_1 = require("../../../table/index.js");
class TableDTO extends index_js_1.TableAction {
    constructor(table) {
        super(table);
        this.name = this.table.name !== undefined ? this.table.getName() : undefined;
        this.partitionKey = this.table.partitionKey;
        this.sortKey = this.table.sortKey;
        this.partitionKey = this.table.partitionKey;
        this.entityAttributeSavedAs = this.table.entityAttributeSavedAs;
    }
    toJSON() {
        return {
            ...(this.name !== undefined ? { name: this.name } : {}),
            partitionKey: this.partitionKey,
            ...(this.sortKey !== undefined ? { sortKey: this.sortKey } : {}),
            entityAttributeSavedAs: this.entityAttributeSavedAs
        };
    }
}
exports.TableDTO = TableDTO;
TableDTO.actionName = 'dto';
